import { DEFAULT_BRANDED_PATH, ImageFormat, IMAGES_PATH, StaticServer } from '@bg-shared';

export const buildUrl = (
    imagePath: string,
    filename: string,
    size: number,
    format: ImageFormat,
    branded = DEFAULT_BRANDED_PATH,
): string =>
    `${StaticServer.name}${IMAGES_PATH}/${imagePath}/${branded}/${filename}-${size}.${format}`;
